import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { clearMemberRejection, overturnMemberRejection } from "../../redux/actions/groupActions";
import { toast } from "react-toastify";

function GroupMemberRejectionControl({
    user,
    group,
    subjectUser,
    clearMemberRejection,
    overturnMemberRejection
}) {

    useEffect(() => {


    }, [])

    function removeMember(e) {
        e.preventDefault();
        clearMemberRejection(subjectUser, group.id)
            .then(() => {
                toast.success(`Rejection Cleared for ${subjectUser.firstName} ${subjectUser.surname}`);
            });
    }

    function acceptMemberRequest(e) {
        e.preventDefault();
        overturnMemberRejection(subjectUser, group.id)
            .then(() => {
                toast.success(`${subjectUser.firstName} ${subjectUser.surname} Added to Group`);
            });
    }


    return (

        user.id.toUpperCase() == subjectUser.userId.toUpperCase() ? "" :
            <div className="dropdown dropleft">
                <button className="btn btn-link" id="dLabel" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span className="fas fa-ellipsis-h more-options"></span>
                </button>
                <div className="dropdown-menu" aria-labelledby="dLabel">
                    <a className="dropdown-item" onClick={removeMember} href="#">Clear Rejection</a>
                    <a className="dropdown-item" onClick={acceptMemberRequest} href="#">Approve Request</a>
                </div>
            </div>
    );
};

GroupMemberRejectionControl.propTypes = {
    user: PropTypes.object.isRequired,
    subjectUser: PropTypes.object.isRequired,
    group: PropTypes.object.isRequired,
    clearMemberRejection: PropTypes.func.isRequired,
    overturnMemberRejection: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
    clearMemberRejection,
    overturnMemberRejection
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupMemberRejectionControl);


// WEBPACK FOOTER //
// ./src/components/groups/GroupMemberRejectionControl.js